// Bounds the ErrorBoundary's automatic recovery from DOM-sync errors.
// A transient race (browser translate / portal teardown) recovers fine, but a
// DETERMINISTIC render error matching the same patterns would otherwise recover
// -> re-render -> throw -> recover forever and hang the tab. We allow a few
// recoveries within a short window; beyond that we treat it as a real loop and
// let the error UI show instead.
export const MAX_RECOVERIES = 3;
export const RECOVERY_WINDOW_MS = 10_000;

export interface RecoveryState {
  count: number;
  lastAt: number;
}

export const initialRecoveryState: RecoveryState = { count: 0, lastAt: 0 };

export function registerRecovery(
  prev: RecoveryState,
  now: number
): { next: RecoveryState; stop: boolean } {
  // Recoveries spaced further apart than the window are unrelated transient
  // races, so the counter resets instead of accumulating over a long session.
  const count = now - prev.lastAt > RECOVERY_WINDOW_MS ? 1 : prev.count + 1;
  return { next: { count, lastAt: now }, stop: count > MAX_RECOVERIES };
}
